import React, { useEffect, useState } from 'react'
import OperatorTable from './OperatorTable';
import CreateOpt from './CreateOpt';
import UpdateOpt from './UpdateOpt';
const OperatorImages = () => {
    const data = ['Table', 'Create', 'Update']
    const [updateData, setUpdateData] = useState(data[0])
    const [getTxnData, setGetTxnData] = useState(null)
    let renderdata
    switch (true) {
        case updateData === 'Table':
            renderdata = <OperatorTable setUpdateData={setUpdateData} setGetTxnData={setGetTxnData} />
            break;
        case updateData === 'Create':
            renderdata = <CreateOpt setUpdateData={setUpdateData} />
            break;
        case updateData === 'Update':
            renderdata = <UpdateOpt setUpdateData={setUpdateData} getTxnData={getTxnData} />
            break;
        default: renderdata = <OperatorTable setUpdateData={setUpdateData} setGetTxnData={setGetTxnData} />
            break;
    }
    return (
        <div className="row">
            <div className="col-12">
                {renderdata}

            </div>
        </div>
    )
}

export default OperatorImages
